import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../config/firebase";
import store from "../store";
import { setSettings } from "../store/slices/settingSlice";
import { getAuth, updateEmail, updatePassword } from "firebase/auth";

export const updateSettings = async (payload) => {
  try {
    const filteredPayload = Object.fromEntries(
      Object.entries(payload).filter(([_, value]) => value !== undefined)
    );

    const reference = doc(db, "settings", "only-object");
    await setDoc(reference, filteredPayload, { merge: true });
    await getSettings();
    return true;
  } catch (error) {
    console.log("Update Settings Error:", error.message);
  }
};

export const getSettings = async () => {
  try {
    const docRef = doc(db, "settings", "only-object");
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      store.dispatch(setSettings(docSnap.data()));
    } else {
      store.dispatch(setSettings(null));
    }
    return true;
  } catch (error) {
    console.log("Get Settings Error:", error.message);
  }
};

export const updateAccount = async (payload, adminEmail) => {
  try {
    const auth = getAuth();
    const _user = auth?.currentUser;
    if (payload?.email !== adminEmail) {
      await updateEmail(_user, payload?.email);
    }
    if (payload?.password?.trim() !== "") {
      await updatePassword(_user, payload?.password);
    }
    return true;
  } catch (error) {
    console.log("Update Settings Error:", error.message);
  }
};
